// Each controller expires its own notice, including notices inserted by cart/variant AJAX.
if (!customElements.get('ka-promotion-expiry')) {
  customElements.define('ka-promotion-expiry', class extends HTMLElement {
    connectedCallback() { this.check(); }
    disconnectedCallback() { clearTimeout(this.timer); }
    check() {
      clearTimeout(this.timer);
      const remaining = Number(this.dataset.end) * 1000 - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.parentElement?.remove();
        return;
      }
      this.timer = setTimeout(() => this.check(), Math.min(remaining, 2147483647));
    }
  });
}
